export const UpTrend = ({ noColor }) => {
    return (
        <svg height="10" viewBox="0 0 64 64" width="10" xmlns="http://www.w3.org/2000/svg" id="fi_10124891">
            <g id="Layer_3">
                <path d="m9.99 42.375 15.009-15.302v36.927h14.002v-36.927l15.009 15.302 9.991-9.749-31.999-32.626-32.003 32.626z" fill={noColor ? "#000" : "#32bea6"}></path>
            </g>
        </svg>
    );
};